import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import * as LucideIcons from 'lucide-react';
import { Button } from './ui/button';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookie-consent', 'all');
    setShowBanner(false);
  };

  const acceptEssential = () => {
    localStorage.setItem('cookie-consent', 'essential');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gray-900 text-white p-4 shadow-2xl border-t-4 border-orange-600">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-start space-x-3">
            <LucideIcons.Cookie className="w-6 h-6 text-orange-500 flex-shrink-0 mt-1" />
            <div>
              <p className="text-sm md:text-base">
                We use cookies to enhance your browsing experience and analyse our traffic. 
                By clicking "Accept All", you consent to our use of cookies.{' '}
                <Link to="/privacy" className="text-orange-400 hover:text-orange-300 underline">
                  Learn more
                </Link>
              </p>
            </div>
          </div>
          <div className="flex space-x-3 flex-shrink-0">
            <Button
              onClick={acceptEssential}
              variant="outline"
              className="border-gray-600 text-gray-300 hover:bg-gray-800"
            >
              Essential Only
            </Button>
            <Button
              onClick={acceptAll}
              className="bg-orange-600 hover:bg-orange-700 text-white"
            >
              Accept All
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
